import classNames from 'classnames';
import { Icon } from 'palette/Icon';
import { useProductCardContext } from 'palette/ProductCard';
import { CARD_THEMES } from 'palette/ProductCard/constants';
import { IColors } from 'palette/ProductCard/types/productData';

import '../styles/Colors.scss';

interface ProductCardColorsProps {
    colors: IColors;
    maxNumberOfColors?: number;
    showInline?: boolean;
}

function Colors({
    colors = [],
    maxNumberOfColors = 5,
    showInline = false,
}: ProductCardColorsProps) {
    const { theme } = useProductCardContext();

    if (!colors?.length) {
        return null;
    }

    const hasToDisplayPlusSign = colors.length > maxNumberOfColors;

    return (
        <ul className={classNames('palette-product-card-colors', {
            'palette-product-card-colors--inline': showInline,
        })}
        >
            {colors.slice(0, maxNumberOfColors).map(color => (
                <li
                    key={color.uniqueId}
                    className={classNames('palette-product-card-colors__item', {
                        'palette-product-card-colors__item--has-border': color.hasBorder || theme === CARD_THEMES.dark,
                    })}
                    style={{
                        background: color.value,
                    }}
                />
            ))}
            {
                hasToDisplayPlusSign
          && (
              <li className="palette-product-card-colors__item">
                  <Icon
                      name="palette_plus"
                      size="xxx-small"
                  />
              </li>
          )
            }
        </ul>
    );
}

export default Colors;
